<script setup>
import Layout from "../../Components/Shared/LayoutAdmin.vue";
import ClassificationForm from "../../Components/Forms/ClassificationForm.vue";
import TableItem from "../../Components/Shared/TableItem.vue";
import ModalComponent from "../../Components/Shared/ModalComponent.vue";
import ButtonComponent from "../../Components/Shared/ButtonComponent.vue";
import { Link } from "@inertiajs/inertia-vue3";
import HeaderAdminComponent from "../../Components/Shared/HeaderAdminComponent.vue";
import UploadClassificationsExcel from "../../Components/Forms/UploadClassificationsExcel.vue";
import UploadClassificationsImage from "../../Components/Forms/UploadClassificationsImage.vue";

import { ref } from "vue";
import useApi from "../../Services/useApi";
import { Inertia } from "@inertiajs/inertia";
import useNotification from "../../Services/useNotification";

const props = defineProps(["classifications"]);
const modalTitle = ref("Crear");
const api = useApi();
const notificate = useNotification()
//clasiffications
const classificationModal = ref(false);
const initClassification = {
    name: "",
    description: "",
    parent_id: null,
    principal: true,
    type: "VITA"
};
const classificationToCreate = ref(initClassification);
const createClassification = () => {
    classificationToCreate.value = initClassification;
    classificationModal.value = true;
    modalTitle.value = "Crear";
};
const editClassification = (classification)  => {
    classificationToCreate.value = classification;
    classificationModal.value = true;
    modalTitle.value = "Editar";
};
const deleteClassification = (classification) => {
    notificate.confirm("Seguro que quieres eliminar esta clasificacion ?",()=>{
        api.deleteClassification(classification).then((response) => {
            console.log(response);
            notificate.success("Eliminado!");
            Inertia.reload();
        });
    })
};
const resetModals = () => {
    classificationModal.value = false;
};
</script>

<template lang="">
    <Layout>
        <HeaderAdminComponent title="Clasificaciones"></HeaderAdminComponent>
        <div class="container w-full mx-auto my-14 px-10">
            <ButtonComponent 
                content="Atrás" 
                :icon="'arrow_back_ios'"
                :link="'/admin'"
                type="2"
            />
            <ButtonComponent 
                content="Añadir nueva clasificación" 
                :icon="null"
                :link="null"
                type="0"
                @click="createClassification" 
            />
            <div class="w-full my-10">
                <UploadClassificationsExcel />
                <UploadClassificationsImage />
                <div class="flex w-full" v-for="item in classifications" :key="item.id">
                    <Link class="w-full" :href="'/classification/'+item.id+'/fruits'">
                        <TableItem :items="[
                            { key: 'id', name: 'ID',value:item.id , width: '10%' },
                            { key: 'name', name: 'Nombre',value:item.name , width: '30%' },
                            { key: 'parent_id', name: 'Padre',value:item.parent_id , width: '30%' },
                            { key: 'principal', name: 'Principal',value:item.principal , width: '30%' },
                        ]" /> 
                    </Link>
                    <div class="w-20 ml-6" v-if="$page.props.isAdmin==true">
                        <div class="flex pt-10">
                            <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/editar_enriqueto.svg" @click="editClassification(item)" alt="">
                            <img class="w-5 mx-2 transform cursor-pointer hover:scale-90 " src="/images/borrar_enriqueto.svg" @click="deleteClassification(item)" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalComponent
            :title="modalTitle + ' categoria'"
            v-model="categoryModal"
            v-if="categoryModal"
        >
            <CategoryForm @added="resetModals" :category="categoryToCreate" />
        </ModalComponent>
    </Layout>
</template>

<style lang="">
    
</style>